module.exports = __webpack_public_path__ + "img/RVBundle.99aea96b.webp";